module.exports = __webpack_public_path__ + "static/media/door.e59a2e26.svg";